<template>
    <div class="pileEquipment">
        <!-- 标题 -->
        <div class="pileEquipment_title">
            <div class="pileEquipment_title_left">站点设备</div>
            <div class="pileEquipment_title_right">
                <div :class="['pileEquipment_title_right_info', type == 0 ? 'pileEquipment_title_right_btn' : '']"
                    @click="type = 0">枪桩设备</div>
                <div :class="['pileEquipment_title_right_info', type == 1 ? 'pileEquipment_title_right_btn' : '']"
                    @click="getDetail">场站信息</div>
            </div>
        </div>
        <!-- 枪桩设备 -->
        <div class="pileEquipment_content_gun" v-if="type == 0">
            <!-- 搜索框 -->
            <div class="search_box">
                <div class="pileEquipment_search">
                    <el-input placeholder="搜索枪编码 / 桩编码" v-model="code" clearable>
                        <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    </el-input>
                </div>
                <button @click="search" class="public_saleWater_chaxun pulic_cursor">
                    查询
                </button>
            </div>
            <!-- 列表 -->
            <div class="pileEquipment_list">
                <el-row type="flex" class="row-bg" style="flex-wrap: wrap;">
                    <el-col :span="12" class="pileEquipment_list_item" v-for="(item, index) in list" :key="index">
                        <div class="pileEquipment_list_item_content">
                            <div class="grid-content bg-purple">
                                <div class="pileEquipment_item_content">
                                    <div class="pileEquipment_item_header">
                                        <div class="pileEquipment_item_header_left">
                                            <span>{{ item.ormtb602ca03 }}：{{ item.ormtb602ca00 }}</span>
                                            <el-tooltip class="item" effect="dark" content="点击查看告警信息记录"
                                                placement="top-start">
                                                <span class="el-icon-warning"
                                                    style="color: #e6a23c;margin-left: 12px;cursor: pointer;"
                                                    @click="getAlarmList(item)"></span>
                                            </el-tooltip>
                                        </div>
                                        <div class="pileEquipment_item_header_right" id="桩重启" v-shiroHiden="solelist"
                                            @click="pileRestart(item)">桩重启
                                        </div>
                                    </div>
                                    <div class="pileEquipment_item_body">
                                        <div class="pileEquipment_body_item" v-for="(it, idx) in item.ormtbGunDetailVos"
                                            :key="idx">
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left"
                                                    style="font-size: 18px;color: #6B7280;font-weight: 700;">{{
                                                        it.ormtb603ca07 }}</div>
                                                <div class="pileEquipment_body_dot"></div>
                                            </div>
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left">输出电流</div>
                                                <div class="pileEquipment_body_line_right">{{ it.exportElectricity ||
                                                    '--' }}</div>
                                            </div>
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left">输出电压</div>
                                                <div class="pileEquipment_body_line_right">{{ it.exportVoltage || '--'
                                                }}
                                                </div>
                                            </div>
                                            <div class="pileEquipment_body_item_line">
                                                <div class="pileEquipment_body_line_left">输出soc</div>
                                                <div class="pileEquipment_body_line_right">{{ it.soc || '--' }}</div>
                                            </div>
                                            <div class="pileEquipment_body_btn" id="订单" v-shiroHiden="solelist"
                                                @click="getOrderList(item.ormtb602ca00)">订单</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 场站信息 -->
        <div class="pileEquipment_info" v-if="type == 1">
            <div class="pileEquipment_info_left">
                <div class="pileEquipment_info_item">
                    充电场站名称：{{ info.ormtb601ca00 }}
                </div>
                <div class="pileEquipment_info_item">
                    详细地址：{{ info.ormtb601ca01 }}
                </div>
                <div class="pileEquipment_info_item">
                    桩数量：{{ info.zsl }}
                </div>
                <div class="pileEquipment_info_item">
                    总功率(Kw)：{{ info.zgl }}
                </div>
                <div class="pileEquipment_info_item">
                    营业状态：{{ info.ormtb601ca04 == 1 ? '运营' : '下架' }}
                </div>
                <!-- <div class="pileEquipment_info_item">
                    站点类型：公用
                </div>
                <div class="pileEquipment_info_item">
                    创建时间：2025-04-07 09:45:57
                </div> -->
                <div class="pileEquipment_info_item">
                    备注: {{ info.ormtb601ca08 }}
                </div>
            </div>
            <div class="pileEquipment_info_right">
                <!-- <div class="pileEquipment_info_item">
                    所属区域：{{ info.ormtb601ca01 }}
                </div> -->
                <!-- <div class="pileEquipment_info_item">
                    运营状态：正常投运
                </div> -->
                <div class="pileEquipment_info_item">
                    可用数量：{{ info.kysl }}
                </div>
                <div class="pileEquipment_info_item">
                    站点电话：{{ info.ormtb601ca05 }}
                </div>
                <!-- <div class="pileEquipment_info_item">
                    建设场所：企事业单位
                </div> -->
                <div class="pileEquipment_info_item">
                    营业时间：{{ info.ormtb601ca07 }}
                </div>
                <!-- <div class="pileEquipment_info_item">
                    投放时间：2025-04-07 09:45:57
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            code: '',
            type: 0,
            list: [],
            info: {},
            solelist: []
        }
    },
    created() {
        var list = ''
        list = this.$store.state.solelist
        var path = this.$route.path
        // 赋值，缓存销毁
        this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
        this.userobj = this.$store.state.uobj
        this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
        this.type = 0;
        this.code = '';
        this.getList();
    },
    methods: {
        // 获取列表
        getList() {
            this.axios.post('/orm/ormtb602/select602GunInfo', {
                key: this.code,
                ormtb601id: '1'
            }).then(res => {
                if (res.data.code == 200) {
                    this.list = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        // 搜索
        search() {
            this.getList();
        },
        //站点详情
        getDetail() {
            this.type = 1;
            this.getStationInfo();
        },
        // 跳转订单
        getOrderList(pileCode) {
            let tabList = this.$store.state.tablist
            const tabIndex = tabList.findIndex(
                item => item.PERTB001CA05 === 'Home:chargingOrder'
            )
            if (tabIndex !== -1) {
                tabList.splice(tabIndex, 1) //移除已存在充电订单
            }
            let path = `/Home/chargingOrder?pileCode=${pileCode}`
            let resitem = {
                PERTB001CA00: '充电订单',
                PERTB001CA03: `${path}`,
                PERTB001CA04: '1',
                PERTB001CA05: 'Home:chargingOrder',
                PERTB001CB00: 'ALL',
            }

            var str = JSON.stringify(tabList)
            var index = str.indexOf('/Home/chargingOrder')
            if (index == -1) {
                var Stablsit = this.$store.state.tablist.slice()
                Stablsit.push(resitem)
                this.$store.commit('upEditableTabs', Stablsit)
            }
            this.$store.commit('setHistTabsValue', path)
            this.$router.push(this.$store.state.setHistTabsValue)
        },
        // 站详情
        getStationInfo() {
            this.axios.post('/orm/ormtb601/ormtb601Detail', {
                ormtb601id: '1'
            }).then(res => {
                if (res.data.code == 200) {
                    this.info = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error'
                    });
                }
            })
        },
        // 桩重启
        pileRestart(item) {
            this.$confirm(`确定要重启${item.ormtb602ca03}吗?`, '重启确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.axios.post('/orm/ormtb602/restart', {
                    pileCode: item.ormtb602ca00
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            type: 'success',
                            message: res.data.message
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            })
        },
        // 查看告警信息
        getAlarmList(item) {
            let tabList = this.$store.state.tablist
            const tabIndex = tabList.findIndex(
                item => item.PERTB001CA05 === 'Home:alarmInformation'
            )
            if (tabIndex !== -1) {
                tabList.splice(tabIndex, 1) //移除已存在
            }
            let path = `/Home/alarmInformation?stationId=1&pileCode=${item.ormtb602ca00}`
            let resitem = {
                PERTB001CA00: '告警信息',
                PERTB001CA03: `${path}`,
                PERTB001CA04: '1',
                PERTB001CA05: 'Home:alarmInformation',
                PERTB001CB00: 'ALL',
            }

            var str = JSON.stringify(tabList)
            var index = str.indexOf('/Home/alarmInformation')
            if (index == -1) {
                var Stablsit = this.$store.state.tablist.slice()
                Stablsit.push(resitem)
                this.$store.commit('upEditableTabs', Stablsit)
            }
            this.$store.commit('setHistTabsValue', path)
            this.$router.push(this.$store.state.setHistTabsValue)
        },
    }
}
</script>
<style scoped>
.pileEquipment {
    background-color: #f3f3f3;
}

.pileEquipment_title {
    display: flex;
    justify-content: space-between;
    padding-top: 20px;
    box-sizing: border-box;
}

.pileEquipment_title_left {
    font-size: 20px;
    color: #000;
}

.pileEquipment_title_right {
    display: flex;
}

.pileEquipment_title_right_btn {
    background: #2B7EFB !important;
    color: #fff !important;
    border: none !important;
}

.pileEquipment_title_right_info {
    width: 89px;
    height: 32px;
    color: #9E9E9E;
    border: 1px solid #D8D8D8;
    background: #FFFFFF;
    border-radius: 6px;
    text-align: center;
    line-height: 32px;
    font-size: 16px;
    margin-left: 20px;
    cursor: pointer;
}

/* 搜索框 */
.pileEquipment_search {
    width: 302px;
    /* margin-top: 40px; */
}

/* 列表 */
.pileEquipment_list {
    margin-top: 40px;
}

.pileEquipment_list_item {
    padding: 10px;
    box-sizing: border-box;
}

.pileEquipment_list_item:nth-child(odd) {
    padding-left: 0;
}

.pileEquipment_list_item:nth-child(even) {
    padding-right: 0;
}

.pileEquipment_list_item_content {
    padding: 0 20px;
    box-sizing: border-box;
    background-color: #fff;
}

.pileEquipment_item_header {
    display: flex;
    justify-content: space-between;
    height: 66px;
    line-height: 66px;
    background-color: #fff;
    border-bottom: 1px solid #D8D8D8;
}

.pileEquipment_item_header_left {
    color: #000000;
    font-size: 26px;
    font-weight: 700;
}

.pileEquipment_item_header_right {
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #199FFF;
    cursor: pointer;
}

/* 列表 */
.pileEquipment_item_body {
    display: flex;
}

.pileEquipment_body_item {
    width: 50%;
    border-right: 1px solid #D8D8D8;
    padding-bottom: 20px;
    box-sizing: border-box;
}

.pileEquipment_body_item:nth-child(even) {
    border-right: none;
    padding-left: 20px;
    box-sizing: border-box;
}

.pileEquipment_body_item:nth-child(odd) {
    padding-right: 20px;
    box-sizing: border-box;
}

.pileEquipment_body_item_line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    box-sizing: border-box;
}

.pileEquipment_body_line_left,
.pileEquipment_body_line_right {
    font-size: 18px;
    color: #9E9E9E;
}

.pileEquipment_body_dot {
    width: 10px;
    height: 10px;
    background: #B3B3B3;
    border-radius: 50%;
}

.pileEquipment_body_btn {
    width: 380px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 6px;
    border: 1px solid #D8D8D8;
    font-size: 18px;
    color: #9E9E9E;
    margin-top: 10px;
    cursor: pointer;
}

/* 场站信息 */
.pileEquipment_info {
    display: flex;
    background-color: #fff;
    min-height: calc(100vh - 220px);
    margin-top: 40px;
    padding: 20px 0;
    box-sizing: border-box;
    font-size: 16px;
}

.pileEquipment_info_right,
.pileEquipment_info_left {
    width: 50%;
    padding: 0 20px;
    box-sizing: border-box;
}

.pileEquipment_info_left {
    border-right: 1px solid #D8D8D8;
}

.pileEquipment_info_item {
    margin-bottom: 10px;
}

.search_box {
    display: flex;
    margin-top: 40px;
    align-items: center;
}
.public_saleWater_chaxun {
    width: 80px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    margin-left: 20px;
}
</style>